<template>

    <LoopItemPanel title="Slide">

        <div class="canvas-blocks-sky-sliderAlfa-LoopItemPanel">

            <LinkInput :options="loopItem"></LinkInput>

        </div>

        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="fas fa-check mr-2"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import LinkInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/LinkInput";
import axios from "../../../../../../../galaxy/modules/Core/resources/js/axiosBuilder";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        SwitchInput,
        LinkInput,

    },

    data() {
        return {
            targets: {
                '_self': 'Huidige pagina',
                '_blank': 'Nieuwe pagina',
            },
        };
    },

    methods: {


    },

}
</script>

<style lang="scss" scoped>

.canvas-blocks-sky-sliderAlfa-LoopItemPanel {

}

</style>
